import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Global } from '@services/core/Global';

@Injectable({ providedIn: 'root' })
export class HelpArticleService {
  private http = inject(HttpClient);
  private base = Global.url + 'V1/help-articles';

  get(params?: { q?: string; activeOnly?: boolean }): Observable<any[]> {
    let httpParams = new HttpParams();
    if (params?.q) httpParams = httpParams.set('q', params.q);
    if (params?.activeOnly != null) {
      httpParams = httpParams.set('activeOnly', String(params.activeOnly));
    }
    return this.http.get<any[]>(this.base, { params: httpParams });
  }

  getByUuid(uuid: string): Observable<any> {
    return this.http.get(`${this.base}/${uuid}`);
  }

  getByRoute(path: string): Observable<any> {
    return this.http.get(`${this.base}/by-route`, {
      params: new HttpParams().set('path', path ?? '')
    });
  }

  create(data: any): Observable<any> {
    return this.http.post(this.base, data);
  }

  update(uuid: string, data: any): Observable<any> {
    return this.http.put(`${this.base}/${uuid}`, data);
  }

  bulkUpdateActive(items: { uuid: string; isActive: boolean }[]): Observable<{ updated: number }> {
    return this.http.post<{ updated: number }>(`${this.base}/bulk-active`, { items });
  }

  delete(uuid: string): Observable<any> {
    return this.http.delete(`${this.base}/${uuid}`);
  }

  static normalizeRoutePath(url: string): string {
    if (!url) return '';
    let p = String(url).trim();
    p = p.replace(/^[/#]+/, '');
    p = p.split('?')[0].split('#')[0];
    p = p.replace(/\/+$/, '');
    return p;
  }
}
